export enum StatusTypeEnum {
  NEW = '1',
  COMPLETED = '2',
  WAITING_FOR_APPROVAL = '100000001',
  DOCUMENTS = '100000002',
  PROCESSED = '100000003',
  CANCELLED = '100000004',
  REJECTED = '100000005',
}

export enum StatusEnum {
  NEW = 'New',
  COMPLETED = 'Completed',
  WAITING_FOR_APPROVAL = 'Waiting For Approval',
  DOCUMENTS = 'Documents',
  PROCESSED = 'Processed',
  CANCELLED = 'Cancelled',
  REJECTED = 'Rejected',
}

export const getStatusCodeNumber = (statusName: string) => {
  const result = Object.entries(StatusTypeEnum).filter(
    ([key]) =>
      key.toLowerCase().replaceAll('_', ' ') === statusName.toLowerCase()
  );

  return result[0][1];
};
